import React, { useCallback } from 'react';
import { Platform } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from '@/hooks/useTranslation';
import NavigationBarButtonContainer from '@/components/Navigation/NavigationBarButtonContainer';
import NavigationBarButton from '@/components/Navigation/NavigationBarButton';
import useAndroidDetailBack from '@/hooks/useAndroidDetailBack';

const TaskTemplateDetailNavigationHeaderLeft = React.memo(() => {
  const router = useRouter();
  const { t } = useTranslation();
  useAndroidDetailBack(router, '/tasks');

  const onBack = useCallback(() => {
    // Drawer navigation gives native detail screens an unrelated back entry
    // (often Home). Keep browser history on web, but make the explicitly
    // labelled native back button return to the Tasks hub every time.
    if (Platform.OS === 'web' && router.canGoBack?.()) {
      router.back();
      return;
    }
    router.replace('/tasks');
  }, [router]);

  return (
    <NavigationBarButtonContainer leftPadding>
      <NavigationBarButton
        icon="chevron-left"
        tooltip={t('nav.routes.taskTemplate.backToTasksTitle')}
        accessibilityLabel={t('nav.routes.taskTemplate.backToTasks')}
        onPress={onBack}
      />
    </NavigationBarButtonContainer>
  );
});

TaskTemplateDetailNavigationHeaderLeft.displayName = 'TaskTemplateDetailNavigationHeaderLeft';

/**
 * /tasks/template/[slug] — detail navigation; setup lives in the page.
 * @param {string} title — header title (template name or fallback)
 */
export function getTaskTemplateDetailRouteNavigationOptions(title) {
  return {
    title,
    headerTitle: title,
    headerBackVisible: false,
    headerShown: true,
    headerLeft: () => <TaskTemplateDetailNavigationHeaderLeft />,
    headerRight: () => null,
  };
}
